import React, {useState} from 'react';
import {Grid, Card, CardActionArea, CardContent, CardMedia, Typography, Divider } from '@material-ui/core/';
import {useStyles} from './style';

import ModalImage from 'components/ImageModal';
import Alert from '@material-ui/lab/Alert';
import Container from '@material-ui/core/Container';
import { CheckCircleOutline, HighlightOff } from '@material-ui/icons';

function DatosIdentidad(props) {
    const classes = useStyles(),
        [verImagen, setVerImagen] = useState(false),
        [datosImagen, setDatosImagen] = useState({image:'', title:'',});

    const splitDate = (date) => {
        if (date !== undefined) {
            var arr1 = date.split("-");
            if(arr1[2] !== undefined){
                var arr2 = arr1[2].split("T");
                var finalDate = arr2[0] + "/" + arr1[1] + "/" + arr1[0];
            }
            return finalDate;
        }
    };

    const VerImagen =(datosImagen)=>{
        if(datosImagen?.imagen)
            setDatosImagen({image: "data:image/png;base64,"+datosImagen.imagen, title: datosImagen.tipo})
        else
            setDatosImagen({image: "assets/IMAGEN_NO_ENVIADA.svg", title: datosImagen.tipo})
        setVerImagen(true)
    }
    const CerrarVerImagen =()=>{
        setVerImagen(false)
    }

    return (
        <div>
            <Grid container className={classes.rootGrid} justify="center" >
                <Grid className={classes.titleGrid} item xs={12} container direction="row" justify="center" alignItems="center">
                    <Typography className={classes.typography} variant="subtitle1" gutterBottom><strong>Fotografías</strong></Typography>                    
                </Grid >
                {props.datos?.imagenes.map((value, index) => (
                <Grid key={index} item>
                    <Card className={classes.rootCard}>
                        <CardActionArea>
                            <div className={classes.contentMedia}>
                                <CardMedia
                                    className={classes.media}                                
                                    alt="image"
                                    image={(value.imagen) ? ("data:image/png;base64,"+value.imagen) : "assets/IMAGEN_NO_ENVIADA.svg"}
                                    title="image"
                                    onClick={
                                        ()=>VerImagen(value)
                                    }
                                />
                            </div>
                            <CardContent  className={classes.cardContent}>
                                <Grid item xs={12} >
                                    <div  className={classes.centerTitle} onClick={()=>VerImagen(value)}><Divider /> <strong>{value.tipo}</strong> <Divider /></div>
                                </Grid >                                
                                <Typography variant="subtitle1" >
                                    <div className={classes.typographyEstado}>                                        
                                        <div>{(value.imagen) ? (<CheckCircleOutline className={classes.send}/>):(<HighlightOff className={classes.NotSend}/>)}</div>
                                        <div><strong>{(value.imagen) ? (" ENVIADA"):(" NO ENVIADA")}</strong></div>                                    
                                    </div>
                                </Typography> 
                                <Typography variant="subtitle1" >{value?.nombreCompletoPrueba}</Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>                                    
                </Grid>
                ))}
                <ModalImage base64={datosImagen.image} title={datosImagen.title} open={verImagen} handleClose={CerrarVerImagen}/>
            </Grid>  
        </div>      
    );
}
export default DatosIdentidad;